/**
 * 数字输入框
 */
export default {
  name: 'number',
  dataType: 'Number',
  label: '数字',
  icon: 'el-icon-c-scale-to-original',
  config: [{
    xtype: 'text',
    options: {
      label: '输入提示',
      name: 'placeholder',
      default: '请输入数字'
    }
  }, {
    xtype: 'number',
    options: {
      label: '最大值',
      name: 'max',
      default: '',
      placeholder: '允许设置的最大数值'
    }
  }, {
    xtype: 'number',
    options: {
      label: '最小值',
      name: 'min',
      default: '',
      placeholder: '允许设置的最小数值'
    }
  }, {
    xtype: 'number',
    options: {
      label: '默认值',
      name: 'defaultVal',
      placeholder: '设置表单默认值'
    }
  }]
};